import { ERROR_CODES } from '@ps/constants';
/**
 * Every failure surfaces as one of these, whether it came from the API, the
 * network, or a timeout. Screens can therefore render a single error path.
 */
export class ApiClientError extends Error {
    code;
    status;
    errors;
    requestId;
    /** True when the request never reached the API (offline, DNS, timeout). */
    isNetworkError;
    constructor(params) {
        super(params.message);
        this.name = 'ApiClientError';
        this.code = params.code;
        this.status = params.status ?? null;
        this.errors = params.errors;
        this.requestId = params.requestId;
        this.isNetworkError = params.isNetworkError ?? false;
    }
    /** The browser believes there is no connection at all. */
    get isOffline() {
        return (this.isNetworkError &&
            typeof navigator !== 'undefined' &&
            navigator.onLine === false);
    }
    get isUnauthenticated() {
        return this.status === 401 || this.code === ERROR_CODES.UNAUTHENTICATED;
    }
    get isForbidden() {
        return this.status === 403 || this.code === ERROR_CODES.FORBIDDEN;
    }
    get isNotFound() {
        return this.status === 404 || this.code === ERROR_CODES.NOT_FOUND;
    }
    get isValidationError() {
        return this.code === ERROR_CODES.VALIDATION_FAILED;
    }
    /** First message for a field, for inline form errors. */
    fieldError(field) {
        return this.errors?.[field]?.[0];
    }
}
export function isApiClientError(error) {
    return error instanceof ApiClientError;
}
export function isApiErrorBody(body) {
    return (typeof body === 'object' &&
        body !== null &&
        'success' in body &&
        body.success === false);
}
//# sourceMappingURL=errors.js.map